import { useContext } from 'react';
import { WindowDimensionsContext } from '../context/WindowDimensionsContext';
/**
 * @deprecated moved to marketplace-ui-common/hooks
 */

export function useWindowDimensionsContext() {
  return useContext(WindowDimensionsContext);
}